export default "__VITE_ASSET__CKpA76F6__"